module.exports = __webpack_public_path__ + "media/images/85/healthy-ba949444b210188cd99fa32fe019e8c6.webp";